/*
 * Lib Module Elements
 */

Lib.Element = (function() {
    let self = {};

    /**
     *
     * @param options_
     * @returns {*}
     */
    self.select = function(options_) {

        let options = $.extend(true, {
            select: false,
            options: {},
            selected: false,
            clear: true,
            empty: false,
            change: false,
            sort: false,
            sortOptgroups: false
        }, options_);

        if (!options.select) {
            options.select = self.spawn('select');
        } else if (typeof options.select === 'string') {
            options.select = self.spawn('select', {name: options.select});
        }

        if (options.clear) {
            options.select.empty();
        }

        let optionsHolder = self.spawn('div');

        // Single dimension
        if ($.isArray(options.options)) {

            $.each(options.options, function(val, text) {
                optionsHolder.append(self.spawn('option', {value: text}, text));
            });

            // Multi dimension
        } else if ($.isPlainObject(options.options)) {

            let optGroup;

            $.each(options.options, function(optgroupLabel, optGroupOptions) {

                // With optgroup
                if ($.isArray(optGroupOptions) && typeof optgroupLabel === 'string') {

                    optGroup = self.spawn('optgroup', {label: optgroupLabel});

                    $.each(optGroupOptions, function(val, text) {
                        let opt = self.spawn('option', {value: ($.isArray(optGroupOptions) ? text : val)}, text);
                        optGroup.append(opt);
                    });

                    optionsHolder.append(optGroup);
                } else if ($.isPlainObject(optGroupOptions) && typeof optgroupLabel === 'string') {

                    optGroup = self.spawn('optgroup', {label: optgroupLabel});

                    $.each(optGroupOptions, function(val, text) {
                        let opt = self.spawn('option', {value: val}, text);
                        optGroup.append(opt);
                    });

                    optionsHolder.append(optGroup);
                } else {
                    // Without optgroup
                    let opt = self.spawn('option', {value: optgroupLabel}, optGroupOptions);
                    optionsHolder.append(opt);
                }

            });
        }

        let optGroups = optionsHolder.find('optgroup');

        if (options.sort) {

            if (optGroups.length === 0) {

                optionsHolder.html(optionsHolder.find('option').sort(function(x, y) {
                    return $(x).text().toLowerCase() > $(y).text().toLowerCase() ? 1 : -1;
                }));

            } else {

                // Sort all options within optgroups
                optGroups.each(function() {
                    $(this).html($(this).find('option').sort(function(x, y) {
                        return $(x).text().toLowerCase() > $(y).text().toLowerCase() ? 1 : -1;
                    }));
                });

            }
        }

        if (options.sortOptgroups) {
            // Now sort the optgroups
            optionsHolder.html(optGroups.sort(function(x, y) {
                return $(x).attr('label').toLowerCase() > $(y).attr('label').toLowerCase() ? 1 : -1;
            }));
        }

        if (options.empty !== false) {
            optionsHolder.prepend(self.spawn('option', {value: ''}, options.empty === true ? '' : options.empty));
        }

        options.select.append(optionsHolder.html());

        if (options.selected !== false) {
            options.select.val(options.selected);
        }

        if (options.change) {
            options.select.trigger('change');
        }

        return options.select;
    };

    /**
     * Spawn a jQuery element
     *
     * @param type
     * @param attrs
     * @param content
     * @param returnAsString
     * @returns {jQuery}
     */

    self.spawn = function(type, attrs, content, returnAsString) {

        if (typeof content === 'undefined' || !content) {
            content = '';
        }

        if (typeof attrs !== 'object') {
            attrs = {};
        }

        let el = $('<' + type + '/>').attr(attrs).html(content);

        if (returnAsString === true) {
            return self.spawn('div', {}, el).html();
        }

        return el;
    };

    /**
     * Get the label that belongs to an element
     * Uses the [id] and the [for] attributes
     *
     * @param inputEl
     * @returns {*}
     */
    self.getLabel = function(inputEl) {

        let id = inputEl.attr('id');
        let inputLabel = $('label[for=\'' + id + '\']');
        if (inputLabel.length === 1) {
            return inputLabel;
        }
        Lib.Debug.warn('Trying to find label for #' + id + ' but found non or more than 1');
        return false;
    };

    /**
     *
     * @param name
     */
    self.findByCakeName = function(name) {

        let nameParts = name.replace(/\.0$/g, '').split('.');

        let ret = {
            element: null,
            isHidden: false,
            exists: false
        };

        let foundElement = $(':input[name=\'data[' + nameParts.join('][') + ']\']');
        if (foundElement.length) {
            ret.exists = true;
            ret.isHidden = foundElement.closest('.input-group.error').is(':hidden');
            ret.element = foundElement;
        }

        return ret;
    };

    /**
     * Function to check wether the element is in the viewport
     * @param el
     * @returns {*}
     */
    self.fitsInViewport = function(el) {
        if (el instanceof $) {
            if (el.length > 1) {
                Lib.Debug.error('Trying to check if element is in viewport, but multiple elements provided');
                return false;
            }
            el = el[0];
        }
        let rect = el.getBoundingClientRect();
        let fitsLeft = (rect.left >= 0 && rect.left <= $(window).width());
        let fitsTop = (rect.top >= 0 && rect.top <= $(window).height());
        let fitsRight = (rect.right >= 0 && rect.right <= $(window).width());
        let fitsBottom = (rect.bottom >= 0 && rect.bottom <= $(window).height());
        return {
            top: fitsTop,
            left: fitsLeft,
            right: fitsRight,
            bottom: fitsBottom,
            all: (fitsLeft && fitsTop && fitsRight && fitsBottom)
        };
    };

    // Special sauce, https://stackoverflow.com/questions/7738117/html-text-overflow-ellipsis-detection
    // This adds jquery filter :truncated, which only gets elements that are overflowing
    $.expr[':'].truncated = function(obj) {
        let $this = $(obj);
        if (!$this.is(':visible')) {
            return false;
        }
        let $c = $this.clone().css({display: 'inline', width: 'auto', visibility: 'hidden'}).appendTo('body');
        let c_width = $c.width();
        $c.remove();
        return c_width > $this.width();
    };

    return self;
})();
